import { CostExplosionManager } from "src/modules/CostExplosionManager/CostExplosionManager";

export const CostExplosionPage: React.FC = () => {
  return <CostExplosionManager />;
};
